module.exports = __webpack_public_path__ + "static/media/1005988.3fc6c8ab.png";